'use client';
import { createMediaQueryContext } from '@s7/base';

var _createMediaQueryContext = createMediaQueryContext(), MediaQueryProvider = _createMediaQueryContext[0], useMediaQueryContext = _createMediaQueryContext[1];

export { MediaQueryProvider, useMediaQueryContext };
